import axios from "axios";
import { useEffect, useState,useRef } from "react";
import { ProductosListar, ProductosTiposListar } from "../../configuracion/apiUrls";
import { ClienteContext } from "./ClienteContext";

export const ClienteState = (props) => {
    const [cliente, setCliente] = useState(null);
    const [listaProductos, setListaProductos] = useState([]);
    const [listaCategoriaProductos, setListaCategoriaProductos] = useState([]);
    const [actualizar, setActualizar] = useState(false);

    const Lista = async () => {
        try {
            const productos = await axios.get(ProductosListar);
            setListaProductos(productos.data || []);
            const categoriasProductos = await axios.get(ProductosTiposListar);
            setListaCategoriaProductos(categoriasProductos.data || []);
        } catch (error) {
            console.error("Error al obtener productos o servicios:", error);
            setListaProductos([]);
        }
    };
    
    const cargado = useRef(false);

    useEffect(() => {
        if (!cargado.current) {
            Lista();
            cargado.current = true;
        }
    }, []);

    return (
        <ClienteContext.Provider
            value={{
                cliente,
                listaProductos,
                listaCategoriaProductos,
                actualizar,
                setActualizar,
                setCliente,
                setListaProductos,
                setListaCategoriaProductos,
                Lista,
            }}
        >
            {props.children}
        </ClienteContext.Provider>
    );
    
};
